import React from 'react';

const DecimalInput = ({name, value, onChange}) => {
    const handleChange = (e) => {
        let fieldValue = e.target.value;

        const first = fieldValue.indexOf(',');

        if (first !== -1) {
            const part1 = fieldValue.substring(0, first + 1);
            let part2 = fieldValue.substring(first + 1);
            part2 = part2.replace(/,/g, '');

            fieldValue = part1 + part2;
        }

        const start = e.target.selectionStart;
        const end = e.target.selectionEnd;

        fieldValue = fieldValue.replace(/[^0-9,-]/g, '');

        e.target.setSelectionRange(start, end);

        onChange(fieldValue);
    }

    return (
        <input type="text"
               id={name}
               name={name}
               value={value}
               className="form-control"
               onChange={handleChange}/>
    );
};

export default DecimalInput;
